import MetaTags from "../../components/MetaTags";
import LecturesPage from "../../features/web/lectures/LecturesPage";

function Lectures() {
    return (
        <>
            <MetaTags
                title="مستر شريف أسامة | المحاضرات"
                description="صفحة المحاضرات على منصة شريف أسامة لمادة اللغة العربية للثانوية العامة. استعرض المحاضرات لتحقيق التفوق الدراسي."
                image="/images/Thumbnail.webp"
                name="Mr Sherif-Osama"
            />
            <LecturesPage />;
        </>
    );
}

export default Lectures;
